import React, { useEffect } from 'react';
import { Breadcrumb, Button, Icon, Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/actions';
import * as selectors from '../../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import PageContainer from '../../../common/PageContainer';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import AdSlotPageInformation from './AdSlotPageInformation';
import AdSlotPageItems from './AdSlotPageItems';
import { adSlotInitialValues, adSlotValidationSchema } from '../../adslot.constants';

const CreateAdSlotPage = ({ updateAdSlot, createAdSlot, getFirms }) => {
  const handleSubmit = adSlot => {
    if (adSlot.id) {
      updateAdSlot(adSlot);
    } else {
      createAdSlot(adSlot);
    }
  };

  useEffect(() => {
    getFirms();
  }, []);

  const getPage = () => (
    <PageContainer>
      <Formik
        onSubmit={handleSubmit}
        initialValues={{ ...adSlotInitialValues }}
        validationSchema={adSlotValidationSchema}
        enableReinitialize
      >
        {formik => (
          <>
            <Breadcrumb>
              <Breadcrumb.Section>
                <Link to="/ad-slot">Ad Slots</Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider icon="chevron right" />
              <Breadcrumb.Section>New Ad Slot</Breadcrumb.Section>
            </Breadcrumb>
            <Menu borderless attached="top">
              <Menu.Item header>
                <Icon name="list alternate outline" />
                New ad slot
              </Menu.Item>
            </Menu>
            <AdSlotPageInformation formik={formik} />
            <AdSlotPageItems formik={formik} />

            <br />
            <Button icon="save" positive content="Save changes" onClick={formik.handleSubmit} />

            <Button
              icon="binoculars"
              disabled={!formik.values.id}
              content="Preview Showcase"
              as="a"
              href={`https://dallas.culturemap.com?showcase_id=${formik.id}&displayType=desktop`}
              target="_blank"
            />
          </>
        )}
      </Formik>
    </PageContainer>
  );

  return <>{getPage()}</>;
};

const mapStateToProps = state => ({
  currentAdSlot: selectors.getCurrentAdSlot(state),
});

const mapDispatchToProps = dispatch => ({
  getAdSlotById: bindActionCreators(actions.adSlot.getAdSlotById, dispatch),
  createAdSlot: bindActionCreators(actions.adSlot.addAdSlot, dispatch),
  updateAdSlot: bindActionCreators(actions.adSlot.updateAdSlot, dispatch),
  setCurrentAdSlot: bindActionCreators(actions.adSlot.setCurrentAdSlot, dispatch),
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateAdSlotPage));
